import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, ViewChild } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { MatDialog } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ContactComponent } from '../contact/contact.component';
import { HappyDaysComponent } from '../happy-days/happy-days.component';
import { BraderieComponent } from '../braderie/braderie.component';
import { MapComponent } from '../map/map.component';
import { ShopService } from '../shop.service';
import { HalloweenComponent } from '../halloween/halloween.component';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent {
  markets: string[] = ['Henri Barbusse', 'Europe', 'Jean Zay'];
  businessSectors$: any;
  selectedShopId: string = null;

  @ViewChild(MapComponent) map!: MapComponent;
  @ViewChild(MatSidenav) drawer!: MatSidenav;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(private route: ActivatedRoute, private router: Router, private breakpointObserver: BreakpointObserver, public dialog: MatDialog, private _snackBar: MatSnackBar, private analytics: AngularFireAnalytics, private shopService: ShopService) { }

  ngOnInit() {
    this.businessSectors$ = this.shopService.getOverviews().pipe(map(overviews =>
      overviews.businessSectors
    ));

    this.isHandset$.subscribe(isHandset => {
      this._snackBar.open("La Ville de Levallois et l'ACAL vous accompagnent avec une mise à jour des commerces ouverts ou proposant des services", 'Masquer', {
        duration: 20 * 1000,
        verticalPosition: isHandset ? 'bottom' : 'top',
        horizontalPosition: isHandset ? 'center' : 'right',
        panelClass: ['white-snackbar']
      });
    });

    this.route.queryParams.subscribe(params => {
      if (params['shop'] !== this.selectedShopId) {
        this.selectedShopId = params['shop'];
      }
    });
  }

  // async toggleBusinessSectorFilter(event: MouseEvent, businessSector: string) {
  //   this.marketFilter = null;

  //   const currentFilter = await this.route.queryParams.toPromise();
  //   // const previousFilter = this.businessSectorFilters;
  //   if (currentFilter['a'] !== businessSector) {
  //     this.analytics.logEvent('select_content', { 'item_id': `business-${businessSector}`, 'content_type': 'business' });
  //     // this.businessSectorFilters = businessSector;
  //     // this.router.navigate(['/map', { id: heroId, foo: 'foo' }]);
  //   }

  //   // TODO : memory leak
  //   this.isHandset$.subscribe(isHandset => {
  //     if (isHandset) {
  //       this.drawer?.close();
  //     }
  //   });
  // }

  // displayShop(shop: any) {
  //   this.analytics.logEvent('select_content', { 'item_id': `shop-${shop.id}`, 'content_type': 'shop' });
  //   this.selectedShopId = shop.id;
  // }

  // displayMarket(market: string) {
  //   if (this.marketFilter == market) {
  //     this.marketFilter = null;
  //   } else {
  //     this.analytics.logEvent('select_content', { 'item_id': `market-${market}`, 'content_type': 'market' });
  //     this.marketFilter = market;
  //     this.clearShopSelection();
  //   }

  //   this.closeDrawer();
  // }

  closeDrawer() {
    // TODO : memory leak
    this.isHandset$.subscribe(isHandset => {
      if (isHandset) {
        this.drawer?.close();
      }
    });
  }

  clearShopSelection() {
    this.router.navigate([], { relativeTo: this.route.firstChild, queryParams: { shop: undefined }, queryParamsHandling: 'merge' });
  }

  displayContact() {
    const dialogRef = this.dialog.open(ContactComponent, {
      // width: '250px',
      data: {}
    });
  }

  displayHappyDays() {
    const dialogRef = this.dialog.open(HappyDaysComponent, {
      // width: '250px',
      data: {}
    });
  }

  displayBraderie() {
    const dialogRef = this.dialog.open(BraderieComponent, {
      // width: '250px',
      data: {}
    });
  }

  displayHalloween() {
    const dialogRef = this.dialog.open(HalloweenComponent, {
      // width: '250px',
      data: {}
    });
  }
}
